export const generateHouses = (request, map) => {
  const { houseId: id, streetName, building, corpus, streetId } = request;

  const address = [streetName, building, corpus ? `к. ${corpus}` : '']
    .filter(Boolean)
    .join(', ');

  const entity = map.get(id) || {
    name: address,
    value: 0,
    id,
    streetId,
  };

  entity.value += 1;
  map.set(id, entity);
};
